import { ApiState, Action } from '../../../../types';
import { serviceReducer, callService } from '../../../../shared/hooks/serviceReducer';
import { OperationBasicItem } from '../../../../services/types/Operation';

export type SearchOperationAction =
  | Action<OperationBasicItem[], { query: string }>
  | {
      type: 'QUERY_NUMBER';
      query: string;
    };

const reducer = (
  state: ApiState<OperationBasicItem[], { query: string }>,
  action: SearchOperationAction
): ApiState<OperationBasicItem[], { query: string }> => {
  switch (action.type) {
    case 'QUERY_NUMBER': {
      return callService(state, { query: action.query });
    }
    default:
      return serviceReducer(state, action);
  }
};

export default reducer;
